import { create } from 'zustand';

interface PendingMessage {
  readonly text: string;
  /**
   * Optional per-message hidden context (e.g. a `/analyze`d trade's
   * structured data). The drain passes it to `sendMessage(text, { context })`
   * so it rides in the gateway payload but stays out of the chat bubble.
   */
  readonly context?: string;
  /** Monotonic ID — lets the consumer detect a fresh push of identical text. */
  readonly id: number;
}

interface BlockTerminalPendingStore {
  readonly pending: PendingMessage | null;
  readonly setPending: (text: string, context?: string) => void;
  readonly consumePending: () => PendingMessage | null;
}

let nextId = 1;

/**
 * One-shot inbox for messages that other UnifiedRfqs surfaces want the
 * Block Terminal to send on the user's behalf (e.g. a "Analyze in
 * Terminal" trade-tape context-menu action). The producer sets, the
 * Block Terminal drains it once the agent is authenticated.
 *
 * Keyed by a monotonic id so the consumer can tell a re-push of the
 * same text from the previous one.
 */
export const useBlockTerminalPendingStore = create<BlockTerminalPendingStore>(
  (set, get) => ({
    pending: null,
    setPending: (text, context) => {
      set({ pending: { text, context, id: nextId++ } });
    },
    consumePending: () => {
      const current = get().pending;
      if (current == null) return null;
      set({ pending: null });
      return current;
    },
  }),
);
